// Shared gate-session status resolution — CR 5.1's grey → yellow/orange → green flow.
//
// Backend `GateSession.status` is one of: pending | acknowledged | active | paused |
// completed | cancelled. 'acknowledged' itself isn't a single color — it's yellow
// while there's still time before departure, orange once departure is close (a
// lateness warning). Every page that renders a session status badge (operator
// session list, gate display queue, supervisor/manager dashboard, admin session
// list) should resolve through this so they all agree on the same threshold instead
// of drifting out of sync with their own copy of the logic.

// Minutes-to-departure threshold below which an acknowledged (not yet initiated)
// session shows orange instead of yellow. POC value — promote to a server-side
// config field (mirrors sync_config.json) if it needs to be tunable without a deploy.
export const ORANGE_THRESHOLD_MINUTES = 15;

// Resolves a session into the status-config key a page should look up. Every status
// except 'acknowledged' passes through unchanged; 'acknowledged' fans out into
// 'acknowledged_yellow' / 'acknowledged_orange' based on time-to-departure.
export function gateSessionStatusKey(session) {
  if (session.status === 'acknowledged') {
    const minutesToDeparture = (new Date(session.departure_time) - Date.now()) / 60000;
    return minutesToDeparture <= ORANGE_THRESHOLD_MINUTES ? 'acknowledged_orange' : 'acknowledged_yellow';
  }
  return session.status;
}
